var _path, _path2, _mask, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicatorLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32048 12.3952H3.11981C2.84381 12.3952 2.61981 12.1712 2.61981 11.8952C2.61981 11.6192 2.84381 11.3952 3.11981 11.3952H7.32048C7.59648 11.3952 7.82048 11.6192 7.82048 11.8952C7.82048 12.1712 7.59648 12.3952 7.32048 12.3952Z",
    fill: "#A0A3BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3945 5.93359H9.19446C8.91846 5.93359 8.69446 5.70959 8.69446 5.43359C8.69446 5.15759 8.91846 4.93359 9.19446 4.93359H13.3945C13.6705 4.93359 13.8945 5.15759 13.8945 5.43359C13.8945 5.70959 13.6705 5.93359 13.3945 5.93359Z",
    fill: "#A0A3BD"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 5,
    height: 5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6004 3.33362H6.75094V7.46135H2.6004V3.33362Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67555 4.33337C4.08289 4.33337 3.60022 4.81071 3.60022 5.39804C3.60022 5.98471 4.08289 6.46137 4.67555 6.46137C5.26889 6.46137 5.75089 5.98471 5.75089 5.39804C5.75089 4.81071 5.26889 4.33337 4.67555 4.33337ZM4.67555 7.46138C3.53155 7.46138 2.60022 6.53604 2.60022 5.39804C2.60022 4.26004 3.53155 3.33337 4.67555 3.33337C5.82022 3.33337 6.75089 4.26004 6.75089 5.39804C6.75089 6.53604 5.82022 7.46138 4.67555 7.46138Z",
    fill: "#A0A3BD"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1923 10.8054C11.5989 10.8054 11.1163 11.2827 11.1163 11.8694C11.1163 12.4567 11.5989 12.9334 12.1923 12.9334C12.7849 12.9334 13.2669 12.4567 13.2669 11.8694C13.2669 11.2827 12.7849 10.8054 12.1923 10.8054ZM12.1923 13.9334C11.0476 13.9334 10.1163 13.0074 10.1163 11.8694C10.1163 10.7314 11.0476 9.80536 12.1923 9.80536C13.3363 9.80536 14.2669 10.7314 14.2669 11.8694C14.2669 13.0074 13.3363 13.9334 12.1923 13.9334Z",
    fill: "#A0A3BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorLight);
export default __webpack_public_path__ + "static/media/indicator-light.9e11f91a0a7417de143e5d49f242d8b4.svg";
export { ForwardRef as ReactComponent };